<template>
    <div class="vue-slot-child pl-20">
        <h3>这里是子组件</h3>
        <br>
        <h3>这里是内嵌组件</h3>
        1、具名插槽 内嵌组件
        <slot name="childNext"></slot>
        <br>
        2、具名插槽 down<slot name="down"></slot>
        <br>
        3、具名插槽 up<slot name="up"></slot>
        <br>
        4、匿名插槽<slot></slot>
    </div>
</template>
<script>
    export default{
        name:'vue-slot-child',
        data() {
            return {}
        },
        mounted(){
            console.log(this.$slots.down)
        }
    }
</script>
<style scoped>
    .vue-slot-child{
        color: orange;
    }
</style>


// WEBPACK FOOTER //
// src/components/main-content/slot/vue-slot-child.vue